import { render } from "./DatatablesVue3.vue?vue&type=template&id=7fa8ce0d"
import script from "./DatatablesVue3.vue?vue&type=script&lang=js"
export * from "./DatatablesVue3.vue?vue&type=script&lang=js"
script.render = render

export default script